<!-- `dataLabels` is bound explicitly. Without it the block set in the component
     never reaches apx-chart and ApexCharts uses its own default — white
     numerals, printed straight onto the sky and gold bars. No computed-style
     sweep catches that: the labels are an SVG `fill`, not CSS colour. -->
<div class="custom-legend">
  <apx-chart
    [id]="chartName"
    [series]="chartOptions.series!"
    [chart]="chartOptions.chart!"
    [title]="chartOptions.title!"
    [plotOptions]="chartOptions.plotOptions!"
    [xaxis]="chartOptions.xaxis!"
    [yaxis]="chartOptions.yaxis!"
    [fill]="chartOptions.fill!"
    [stroke]="chartOptions.stroke!"
    [dataLabels]="chartOptions.dataLabels!"
    [tooltip]="chartOptions.tooltip!"
  ></apx-chart>
</div>
